import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('../views/HomeView.vue')
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('../views/AboutView.vue')
    },
    {
      path: '/products',
      name: 'products',
      component: () => import('../views/ProductsView.vue')
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import('../views/ContactView.vue')
    },
    // 物流专线页面
    {
      path: '/logistics/:route',
      name: 'logistics-route',
      component: () => import('../views/LogisticsRoute.vue'),
      props: true
    },
    // 目的地详情页面
    {
      path: '/destinations/:destination',
      name: 'destination-detail',
      component: () => import('../views/DestinationDetail.vue'),
      props: true
    },
    // 404 处理 - 必须放在最后
    {
      path: '/:pathMatch(.*)*',
      name: 'not-found',
      component: () => import('../views/HomeView.vue')
    }
  ]
})

export default router